module.exports = __webpack_public_path__ + "static/greeting_img1@2x-86f02bb1ff168c3214e079d11b38174d.png";